import { LANGUAGES_WIDGET, LOCALES_WIDGET } from 'src/comps/TrustPilot/constants'

export const existsLocale = (locale: string) => {
  return LOCALES_WIDGET.some(l => l === locale)
}

export const existLanguage = (language: string) => {
  return LANGUAGES_WIDGET.some(l => l === language)
}
